import { z } from "zod";

// Preserve Latin spelling (including French accents), numbers and ordinary
// shipping punctuation. Validate only; never transliterate or strip input.
export const shippingTextSchema = z
  .string()
  .regex(
    /^(?:\p{Script=Latin}\p{M}*|[0-9 .,'’&()/#-])*$/u,
    "Use English or French letters, numbers, spaces, and standard punctuation."
  );

export class ShippingTextError extends Error {}

export function validateShippingAddress(
  address: {
    name?: string;
    company?: string;
    line1: string;
    line2?: string;
    city: string;
  },
  label: string
): void {
  for (const field of ["name", "company", "line1", "line2", "city"] as const) {
    const value = address[field];
    if (value === undefined) continue;
    const result = shippingTextSchema.safeParse(value);
    if (!result.success)
      throw new ShippingTextError(
        `${label} ${field}: ${result.error.issues[0].message}`
      );
  }
}
